import EnumCustomTextRendererCreator from "../EnumCustomTextRendererCreator.js";
export default EnumCustomTextRendererCreator.createRenderer('resourceEnum');